import { Storage } from '@bihu/common-js'
import { CACHED_URL_PARAMS } from '@/constants/storage'

export function addCachedParamsToLogin(loginParams: any): any {
  const cachedParams = Storage.get(CACHED_URL_PARAMS)

  if (cachedParams && typeof cachedParams === 'object') {
    return {
      ...loginParams,
      ...cachedParams
    }
  }

  return { ...loginParams }
}

/**
 * 将缓存的参数转换为URL查询字符串
 * @returns {string} 返回查询字符串，如：?ext_youdao=xxxx&track_id=yyyy
 */
export function getCachedParamsAsQueryString(): string {
  const cachedParams = Storage.get(CACHED_URL_PARAMS)

  if (!cachedParams || typeof cachedParams !== 'object') {
    return ''
  }

  const params: string[] = []
  Object.keys(cachedParams).forEach(key => {
    const value = cachedParams[key]
    if (value) {
      params.push(`${key}=${encodeURIComponent(value)}`)
    }
  })

  return params.length > 0 ? `?${params.join('&')}` : ''
}

/**
 * 登录成功后清除缓存的参数
 */
export function clearCachedParams(): void {
  Storage.remove(CACHED_URL_PARAMS)
}